import type { RefObject } from 'react';

//TODO: 추후 useEffect까지 내장하는 게 좋을지 리서치 후 리팩토링 진행 (필요하다면)
function observeResizeEvent<T extends Element>(
  ref: RefObject<T | null>,
  resizeHandler: ResizeObserverCallback,
) {
  const resizeObserver = new ResizeObserver(resizeHandler);

  if (ref?.current && ref.current instanceof Element) {
    resizeObserver.observe(ref.current);
  }

  return () => {
    resizeObserver.disconnect();
  };
}

export default observeResizeEvent;
